// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".title[data-v-180f85e8]{font-weight:600;font-size:1.25rem}.v-btn[data-v-180f85e8]{font-size:.875rem}.v-btn:not(.v-btn--round).v-size--default[data-v-180f85e8]{height:2rem}.v-btn[data-v-180f85e8]:hover{text-decoration:none}", ""]);
// Exports
module.exports = exports;
